import React from 'react';
import { useSelector } from 'react-redux'
import CouponContainer from '../../coupon/containers/CouponContainer';
import TicketPickerPage from './TicketPickerPage';
import { showPresaleCouponForm } from '../../coupon/selectors/coupon';

const EmbeddedTicketPicker = props => {
    const isCouponRoute = useSelector(state => state.ui.currentRouteName === 'coupon');
    const overlay       = useSelector(state => !!state.ui.overlay);
    const showPresale   = useSelector(state => showPresaleCouponForm(state));
    return (isCouponRoute || showPresale) && !overlay
        ? <CouponContainer asOverlay={false} canCancelPresale={false} />
        : <TicketPickerPage isEmbeddedPicker />;
}

export default EmbeddedTicketPicker;
